module.exports = __webpack_public_path__ + "assets/android@2x.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/devices/android@2x.png
// module id = 439
// module chunks = 19